import { render, staticRenderFns } from "./LineTitle.vue?vue&type=template&id=6073f069&lang=pug&"
import script from "./LineTitle.vue?vue&type=script&lang=ts&"
export * from "./LineTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports